import { useSelector } from 'react-redux'

import { selectAlert } from 'redux/selectors/Applications/Alert'

export const useAlert = () => {
  return useSelector(selectAlert)
}
